import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ActivityDto } from 'src/app/types/dto/activity.dto'
import { environment } from 'src/environments/environment'
import { AuthService } from '../auth.service'
import { HttpHelperService } from '../http.service'
import { TimedCache } from '../timed-cache'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class ActivitiesApiService {
  private httpHelper = inject(HttpHelperService);
  private auth = inject(AuthService);
  private logger = inject(LogService);
  private http = inject(HttpClient);

  private cachedActivities = new TimedCache<ActivityDto[]>()

  constructor() {
    this.httpHelper.clearCaches.subscribe(() => this.cachedActivities.clear())
  }

  /** assumes activities ordered in the API (by activityCode ascending) */
  getActivities(activeOnly = true): Observable<ActivityDto[]> {
    const comp = this.auth.getCurrentCompany()
    if (!comp) {
      this.logger.log('activities.api', 'getActivities', null, 'no company set')
      throw Error('no company set in getActivities')
    }

    return this.cachedActivities.get(`${comp.id}:${activeOnly}`, () =>
      this.http
        .get<ActivityDto[]>(
          environment.apiUrl + 'activities?activeOnly=' + activeOnly,
          this.httpHelper.httpReadOnlyOptions
        )
    )
  }

}
